module.exports = __webpack_public_path__ + "img/e_2_13_g.1096a7b7.png";